import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { RotateCcw } from "lucide-react";

export default function PaymentCancel() {
  return (
    <main className="min-h-screen flex items-center justify-center px-6" data-testid="payment-cancel-page">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.65, 0, 0.35, 1] }}
        className="max-w-lg w-full text-center"
      >
        <RotateCcw className="mx-auto text-[#78716C] mb-8" size={48} strokeWidth={1.2} />
        <div className="section-tag mb-4">Checkout cancelled</div>
        <h1 className="font-display text-4xl md:text-5xl tracking-tight mb-4">No charge was made.</h1>
        <p className="text-[#78716C] mb-10">The doctrine is still here whenever you are ready.</p>
        <div className="flex flex-wrap gap-3 justify-center">
          <Link to="/modules" className="btn-ember text-sm">Back to Pricing</Link>
          <Link to="/" className="btn-outline text-sm">Home</Link>
        </div>
      </motion.div>
    </main>
  );
}
